/* @flow */
import BoxBody from 'components/BoxBody.jsx';
import Dialog from 'components/Dialog.jsx';
import React from 'react';
import TextAppLink from 'user/components/TextAppLink.jsx';

export default class extends React.Component {
  render() {
    return (
      <Dialog eventScreenName="TextAppLinkDialog" className="TextAppLinkDialog" size="large" onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <TextAppLink />
        </BoxBody>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/user/components/TextAppLinkDialog.jsx